// extracted by mini-css-extract-plugin
module.exports = {"link":"_2pBya","icon":"_3P-0c","icon_small":"Vadgc","icon_medium":"_16FxF","count":"_1l6rN","summary":"z0Eie"};